import { getAvailableCustomCalendars } from '@thoughtspot/session-service';
import _ from 'lodash';
export const CUSTOM_CALENDAR_DEFAULT = 'DEFAULT';
export const CUSTOM_CALENDAR_NONE = 'NONE';
export const FISCAL_CALENDAR_NAME = 'fiscal';
export const GREGORIAN_CALENDAR_NAME = 'calendar';
export const DEFAULT_DATASOURCE_ID = '43121d86-347a-4dbb-bea8-5e5bb899e427';
export const CUSTOM_CALENDAR_DATATYPES = [
    'DATE',
    'DATE_TIME',
    'DATE_NUM_ABS_DAY',
    'DATE_NUM_ABS_MONTH',
    'DATE_NUM_ABS_QUARTER',
    'DATE_NUM_ABS_YEAR',
    'DATE_NUM_DAY_IN_MONTH',
    'DATE_NUM_DAY_IN_QUARTER',
    'DATE_NUM_DAY_IN_YEAR',
    'DATE_NUM_DAY_OF_WEEK',
    'DATE_NUM_MONTH_IN_QUARTER',
    'DATE_NUM_MONTH_IN_YEAR',
    'DATE_NUM_WEEK_IN_YEAR',
    'DATE_NUM_WEEK_IN_QUARTER',
    'DATE_NUM_WEEK_IN_MONTH',
    'DATE_NUM_QUARTER_IN_YEAR',
    'DATE_NUM_HOUR_IN_DAY',
];
let datsourceIdToCustomCalendarMap = {};
const customCalendarGUIDToNameMap = {};
export function initCustomCalendarGUIDToNameMap() {
    _.keys(datsourceIdToCustomCalendarMap).forEach((datasourceId) => {
        _.keys(datsourceIdToCustomCalendarMap[datasourceId]).forEach((calendarName) => {
            const calendarGUID = datsourceIdToCustomCalendarMap[datasourceId][calendarName];
            customCalendarGUIDToNameMap[calendarGUID] = calendarName;
        });
    });
}
export function initAvailableCustomCalendars() {
    datsourceIdToCustomCalendarMap = getAvailableCustomCalendars();
    initCustomCalendarGUIDToNameMap();
}
export function updateAvailableCustomCalendars(updatedCalendarsList) {
    datsourceIdToCustomCalendarMap = updatedCalendarsList;
    initCustomCalendarGUIDToNameMap();
}
export function getCustomCalendarName(guid) {
    return customCalendarGUIDToNameMap[guid];
}
export function getCustomCalendarGuid(name, datasourceId = DEFAULT_DATASOURCE_ID) {
    return datsourceIdToCustomCalendarMap[datasourceId]
        ? datsourceIdToCustomCalendarMap[datasourceId][name]
        : undefined;
}
export function getAvailableCalendarNames(datasourceId) {
    return _.keys(datsourceIdToCustomCalendarMap[datasourceId]).sort();
}
export function getAllAvailableCalendarNames() {
    return _.values(customCalendarGUIDToNameMap).sort();
}
export function getStartEpoch(date) {
    if (_.has(date, 'v') && _.has(date.v, 's')) {
        return date.v.s;
    }
    return null;
}
export function getStartEpochMS(date) {
    const startEpoch = getStartEpoch(date);
    if (startEpoch) {
        return startEpoch * 1000;
    }
    return null;
}
export function getExclusiveEndEpoch(date) {
    if (_.has(date, 'v') && _.has(date.v, 'e')) {
        return date.v.e;
    }
    return null;
}
export function getEndEpoch(date) {
    const exclusiveEndEpoch = getExclusiveEndEpoch(date);
    if (exclusiveEndEpoch) {
        return exclusiveEndEpoch - 1;
    }
    return null;
}
export function getEndEpochMS(date) {
    const exclusiveEndEpoch = getExclusiveEndEpoch(date);
    if (exclusiveEndEpoch) {
        return exclusiveEndEpoch * 1000 - 1;
    }
    return null;
}
export function getDisplayString(date) {
    if (_.has(date, 'd')) {
        return date.d;
    }
    return null;
}
export function getCustomCalendarDateBucketBoundaries(date) {
    const startEpochMS = getStartEpochMS(date);
    const endEpochMS = getEndEpochMS(date);
    if (startEpochMS && endEpochMS) {
        return [startEpochMS, endEpochMS];
    }
    return null;
}
export function isCustomCalendarEnabled() {
    return !_.isEmpty(datsourceIdToCustomCalendarMap);
}
export function getCustomCalendarValueFromEpoch(dateEpoch, options) {
    if (options.hasCustomCalendar &&
        _.has(options.displayToCustomCalendarValueMap, dateEpoch)) {
        return options.displayToCustomCalendarValueMap[dateEpoch];
    }
    return null;
}
//# sourceMappingURL=index.js.map